import { useStaticQuery, graphql } from 'gatsby';
import PropTypes from 'prop-types';
import { cloneDeep } from 'lodash';
import Seo from 'gatsby-plugin-wpgraphql-seo';
import React from 'react';
import socialImageFallback from '../assets/images/social-card.png';
import getMetaImage from '../utils/get-meta-image';
function SEO({
  title,
  description,
  image: metaImage,
  seo,
  ...other
}) {
  const { wp } = useStaticQuery(
    graphql`
      query {
        wp {
          generalSettings {
            title
            description
          }

          themeGeneralSettings {
            siteOptions {
              twitterHandle
            }
          }
        }
      }
    `
  );
  const post = { seo: cloneDeep(seo) };
  
  if(post) {
    let image = {};

    if( metaImage ) {
      const img = getMetaImage(metaImage);
      image = {
        ...img,
        src: img.src?.startsWith('http') ? img.src : `${process.env.GATSBY_SITE_URL}${img.src}`
      };
    } else {
      image = {
        src: `${process.env.GATSBY_SITE_URL}${socialImageFallback}`,
        width: 1200,
        height: 630
      };
    }

    if(!post.seo.opengraphImage) {
      post.seo.opengraphImage = {
        ...post.seo.opengraphImage,
        sourceUrl: image.src
      };
    }

    if(!post.seo.twitterImage) {
      post.seo.twitterImage = {
        ...post.seo.twitterImage,
        sourceUrl: image.src
      };
    } 
    
    post.seo.metaDesc = post.seo.metaDesc || description;
  }

  
  if(!post.seo.title && title) {
    title = `${title} | ${wp.generalSettings.title}`;
  }

  return (
    <Seo {...other} post={post} title={title}/>
  );
}

SEO.defaultProps = {
  description: ``,
  seo: {}
};

SEO.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  seo: PropTypes.object,
  meta: PropTypes.array,
  postSchema: PropTypes.object,
  image: PropTypes.shape({
    src: PropTypes.string.isRequired,
    height: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
  })
};

export default SEO;
